import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SearchSatisfactionBanner from './SearchSatisfactionBanner'
import useSearchSatisfactionBanner from './useSearchSatisfactionBanner'
import renderResultsWithBanner from './renderResultsWithBanner'
import { isGcpsDistrictSelector } from '../../../selectors/user'

const SearchSatisfactionResultsList = ({
  items,
  renderItem,
  filter,
  searchId,
  libraryType,
  surface,
  viewMode,
  gridCountInARow,
  searchFingerprint,
  isGcpsDistrict,
}) => {
  const {
    shouldInsertBanner,
    activeVote,
    onThumbsUp,
    onThumbsDown,
    onDismiss,
  } = useSearchSatisfactionBanner({
    searchFingerprint,
    itemCount: items.length,
    viewMode,
    gridCountInARow,
    libraryType,
    surface,
    searchId,
    filter,
    items,
    isGcpsDistrict,
  })

  const bannerNode = shouldInsertBanner ? (
    <SearchSatisfactionBanner
      activeVote={activeVote}
      onThumbsUp={onThumbsUp}
      onThumbsDown={onThumbsDown}
      onDismiss={onDismiss}
    />
  ) : null

  return renderResultsWithBanner({
    items,
    renderItem,
    bannerNode,
    shouldInsertBanner,
    viewMode,
    gridCountInARow,
  })
}

SearchSatisfactionResultsList.propTypes = {
  items: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  filter: PropTypes.object,
  searchId: PropTypes.string,
  libraryType: PropTypes.oneOf(['test', 'item']).isRequired,
  surface: PropTypes.oneOf(['testLibrary', 'itemLibrary', 'addItems'])
    .isRequired,
  viewMode: PropTypes.oneOf(['list', 'tile']),
  gridCountInARow: PropTypes.number,
  searchFingerprint: PropTypes.string.isRequired,
  isGcpsDistrict: PropTypes.bool,
}

SearchSatisfactionResultsList.defaultProps = {
  filter: {},
  searchId: '',
  viewMode: 'list',
  gridCountInARow: 3,
}

export default connect((state) => ({
  isGcpsDistrict: isGcpsDistrictSelector(state),
}))(SearchSatisfactionResultsList)
